import React from 'react';
import { HierarchyFolder, TileInfo } from 'app/home/index.functions';
import { UserAuth } from 'store/auth';
import { alpha, Box, Tooltip } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import { Tile4FavoriteData } from 'app/home/index';
import useBundleTranslation from 'i18n';

const NamesToDisplay = 2;
export type TileFavoriteIconInfo = {
    element_id: number | null;
    segment_value_id: number | null;
    element_type: string | null;
    is_in_favorites: string | null;
    element_dashboard_name: string | null;
    in_favorites: string | null;
    has_access: string | null;
};
export const TileFavoriteIcon = function ({
    style,
    defaultStyle,
    tile,
    setTile4Favorite,
    favorites,
}: {
    style?: any;
    defaultStyle?: any;
    tile: TileFavoriteIconInfo;
    setTile4Favorite: (data: Tile4FavoriteData | null) => void;
    favorites: HierarchyFolder[];
}) {
    const { t } = useBundleTranslation('app/favorites');

    const favoriteIcon = tile.is_in_favorites ? 'favorite-solid' : 'favorite';

    const elementId = tile.element_id ?? 0;
    const segmentValueId = tile.segment_value_id ?? 0;
    const favoritesIds = tile.in_favorites ? tile.in_favorites.split(',') : [];

    const onFavoriteClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        event.preventDefault();

        setTile4Favorite({
            elementId,
            segmentValueId,
            elementName: tile.element_dashboard_name ?? '',
        });
    };

    const favoritesCount = favoritesIds.length;

    const favoritesList =
        favoritesIds
            .slice(0, NamesToDisplay)
            .map((id) => favorites.find((favorite) => favorite.favorite_id === parseInt(id))?.name)
            .join(', ') + (favoritesCount > NamesToDisplay ? ', ...' : '');

    const tooltip = t('addFavorites', { count: favoritesCount, list: favoritesList, entity: tile.element_type });

    if (tile.has_access == 'N') return null;

    return (
        <Tooltip title={tooltip}>
            <Box
                className={'tile-element__favorite'}
                sx={{
                    display: 'flex',
                    color: (theme) => (tile.is_in_favorites ? 'warning.main' : alpha(theme.palette.text.primary, 0.64)),
                    cursor: 'pointer',
                }}
                style={{ ...style, ...defaultStyle, cursor: 'pointer' }}
                onClick={onFavoriteClick}
            >
                <IconMi icon={favoriteIcon} fontSize={'16'} />
            </Box>
        </Tooltip>
    );
};
